<template>
    <!--
      BLOCO S — item 34, complemento encontrado na auditoria final.

      O envio do feedback já tinha tela (botão no cabeçalho do painel e do PWA). O que
      existia apenas por API era o outro lado: ver os próprios feedbacks e, para os perfis
      de rede, triar e responder a fila. Sem esta tela, `feedback-produto/meus`,
      `/listar` e `/responder/{id}` eram funcionalidade inalcançável pela interface.
    -->
    <div class="main">
        <el-tabs type="border-card" v-model="aba" @tab-click="carregar">
            <el-tab-pane label="MEUS FEEDBACKS" name="meus">
                <el-alert v-if="erro" :title="erro" type="error" :closable="false" class="u-mb-10"></el-alert>

                <div v-if="carregando" class="u-text-center u-mt-20">Carregando...</div>

                <el-table v-else :data="meus" border size="mini"
                          empty-text="Você ainda não enviou nenhum feedback.">
                    <el-table-column label="Enviado em" width="130">
                        <template slot-scope="s">{{ s.row.criado_em || '—' }}</template>
                    </el-table-column>
                    <el-table-column label="Categoria" width="110">
                        <template slot-scope="s">{{ rotuloCategoria(s.row.categoria) }}</template>
                    </el-table-column>
                    <el-table-column label="Nota" width="80">
                        <template slot-scope="s">
                            <span v-if="s.row.nota === null" class="vazio">—</span>
                            <span v-else>{{ s.row.nota }}/5</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="mensagem" label="Mensagem" min-width="240"></el-table-column>
                    <el-table-column label="Situação" width="120">
                        <template slot-scope="s">
                            <el-tag size="mini" :type="corSituacao(s.row.situacao)">{{ rotuloSituacao(s.row.situacao) }}</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column label="Resposta" min-width="200">
                        <template slot-scope="s">
                            <span v-if="!s.row.resposta" class="vazio">Ainda sem resposta</span>
                            <span v-else>{{ s.row.resposta }}</span>
                        </template>
                    </el-table-column>
                </el-table>
            </el-tab-pane>

            <!--
              A aba da fila só existe para perfis de rede. Esconder é conveniência: o
              Service recusa `listar` e `responder` para qualquer outro perfil.
            -->
            <el-tab-pane v-if="ehRede" label="FILA DE FEEDBACKS" name="fila">
                <el-form :inline="true" class="u-mb-10">
                    <el-form-item label="Situação">
                        <el-select v-model="filtro.situacao" clearable placeholder="Todas" @change="carregarFila">
                            <el-option v-for="s in situacoes" :key="s" :label="rotuloSituacao(s)" :value="s"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="Categoria">
                        <el-select v-model="filtro.categoria" clearable placeholder="Todas" @change="carregarFila">
                            <el-option v-for="c in categorias" :key="c" :label="rotuloCategoria(c)" :value="c"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="Origem">
                        <el-select v-model="filtro.origem" clearable placeholder="Todas" @change="carregarFila">
                            <el-option label="Diário" value="diario"></el-option>
                            <el-option label="Painel web" value="web"></el-option>
                            <el-option label="Portal do aluno" value="portal_aluno"></el-option>
                            <el-option label="Aplicativo" value="mobile"></el-option>
                        </el-select>
                    </el-form-item>
                </el-form>

                <el-alert v-if="erroFila" :title="erroFila" type="error" :closable="false" class="u-mb-10"></el-alert>

                <div v-if="carregandoFila" class="u-text-center u-mt-20">Carregando...</div>

                <el-table v-else :data="fila" border size="mini"
                          empty-text="Nenhum feedback para os filtros informados.">
                    <el-table-column label="Enviado em" width="130">
                        <template slot-scope="s">{{ s.row.criado_em || '—' }}</template>
                    </el-table-column>
                    <el-table-column prop="autor" label="Autor" width="150"></el-table-column>
                    <el-table-column label="Origem / tela" min-width="160">
                        <template slot-scope="s">
                            {{ s.row.origem }}<br>
                            <small class="vazio">{{ s.row.tela || '—' }}</small>
                        </template>
                    </el-table-column>
                    <el-table-column label="Categoria" width="110">
                        <template slot-scope="s">{{ rotuloCategoria(s.row.categoria) }}</template>
                    </el-table-column>
                    <el-table-column label="Nota" width="70">
                        <template slot-scope="s">
                            <span v-if="s.row.nota === null" class="vazio">—</span>
                            <span v-else>{{ s.row.nota }}/5</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="mensagem" label="Mensagem" min-width="220"></el-table-column>
                    <el-table-column label="Situação" width="120">
                        <template slot-scope="s">
                            <el-tag size="mini" :type="corSituacao(s.row.situacao)">{{ rotuloSituacao(s.row.situacao) }}</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column label="" width="100">
                        <template slot-scope="s">
                            <el-button size="mini" @click="abrirResposta(s.row)">RESPONDER</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-tab-pane>
        </el-tabs>

        <el-dialog title="Responder feedback" :visible.sync="dialog" width="460px">
            <div v-if="selecionado">
                <p class="mensagem-original">{{ selecionado.mensagem }}</p>

                <el-form label-position="top">
                    <el-form-item label="Situação">
                        <el-select v-model="form.situacao" style="width: 100%;">
                            <el-option v-for="s in situacoes" :key="s" :label="rotuloSituacao(s)" :value="s"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="Resposta ao usuário">
                        <el-input v-model="form.resposta" type="textarea" :rows="4" maxlength="4000"
                                  show-word-limit></el-input>
                    </el-form-item>
                    <el-alert v-if="erroForm" :title="erroForm" type="error" :closable="false"></el-alert>
                </el-form>
            </div>

            <span slot="footer">
                <el-button @click="dialog = false">CANCELAR</el-button>
                <el-button class="u-ml-10" type="primary" :loading="salvando" @click="responder()">SALVAR</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
const CATEGORIAS = { elogio: 'Elogio', problema: 'Problema', sugestao: 'Sugestão' }
const SITUACOES = { novo: 'Novo', em_analise: 'Em análise', respondido: 'Respondido', encerrado: 'Encerrado' }
const CORES = { novo: 'warning', em_analise: 'info', respondido: 'success', encerrado: 'info' }

export default {
    data: () => ({
        aba: 'meus',
        meus: [],
        fila: [],
        categorias: Object.keys(CATEGORIAS),
        situacoes: Object.keys(SITUACOES),
        filtro: { situacao: '', categoria: '', origem: '' },
        selecionado: null,
        form: { situacao: 'respondido', resposta: '' },
        dialog: false,
        carregando: false,
        carregandoFila: false,
        salvando: false,
        erro: '',
        erroFila: '',
        erroForm: ''
    }),
    computed: {
        ehRede () {
            const t = this.$store.state.user ? Number(this.$store.state.user.tipo) : null
            // Espelha FeedbackProdutoService::PERFIS_ADMIN. O backend confere de novo.
            return t === 4 || t === 5
        }
    },
    mounted () {
        this.carregarMeus()
    },
    methods: {
        carregar () {
            if (this.aba === 'meus') this.carregarMeus()
            else this.carregarFila()
        },

        carregarMeus () {
            this.erro = ''
            this.carregando = true

            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/feedback-produto/meus`,
                            this.$store.getters.getHeaderAuth).then(r => {
                this.carregando = false
                const d = r.data || {}
                if (d.erro || d.error) { this.erro = d.erro || d.error; return }
                this.meus = d.feedbacks || []
            }).catch(e => { this.carregando = false; this.erro = this.msgErro(e) })
        },

        carregarFila () {
            if (!this.ehRede) return

            this.erroFila = ''
            this.carregandoFila = true

            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/feedback-produto/listar`,
                             this.filtro, this.$store.getters.getHeaderAuth).then(r => {
                this.carregandoFila = false
                const d = r.data || {}

                // O Service recusa a fila para perfil não autorizado — a mensagem é exibida.
                if (d.erro || d.error) { this.erroFila = d.erro || d.error; return }

                this.fila = d.feedbacks || []
            }).catch(e => { this.carregandoFila = false; this.erroFila = this.msgErro(e) })
        },

        abrirResposta (linha) {
            this.selecionado = linha
            this.erroForm = ''
            this.form = { situacao: linha.situacao === 'novo' ? 'respondido' : linha.situacao,
                          resposta: linha.resposta || '' }
            this.dialog = true
        },

        responder () {
            this.erroForm = ''
            this.salvando = true

            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/feedback-produto/responder/${this.selecionado.id}`,
                             this.form, this.$store.getters.getHeaderAuth).then(r => {
                this.salvando = false
                const d = r.data || {}

                if (d.erro || d.error) { this.erroForm = d.erro || d.error; return }

                this.dialog = false
                this.$message.success(d.mensagem || 'Feedback atualizado.')
                this.carregarFila()
            }).catch(e => { this.salvando = false; this.erroForm = this.msgErro(e) })
        },

        rotuloCategoria (c) { return c ? (CATEGORIAS[c] || c) : '—' },
        rotuloSituacao (s) { return SITUACOES[s] || s },
        corSituacao (s) { return CORES[s] || 'info' },

        msgErro (e) {
            const d = (e && e.response && e.response.data) ? e.response.data : {}
            return d.erro || d.error || 'Não foi possível concluir a operação.'
        }
    }
}
</script>

<style scoped>
.vazio { color: #c0c4cc; }
.mensagem-original { background: #f5f7fa; padding: 10px; border-radius: 4px;
                     font-size: 13px; margin-bottom: 15px; }
</style>
